module.exports = __webpack_public_path__ + "img/badge-percent.15e3da47.svg";